import React from "react";
import { OrnamentDivider } from "./Ornaments";

const AUTHOR_PHOTO =
  "https://customer-assets.emergentagent.com/job_crewed-by-magic/artifacts/a4vx58re_Screenshot%202026-06-30%20at%206.26.15%E2%80%AFPM.png";

export default function AboutAuthor() {
  return (
    <section
      id="about"
      data-testid="about-author"
      className="relative py-24 md:py-32 bg-[#06090e] reveal overflow-hidden"
      aria-label="About the author Chelsea Ray"
    >
      <div className="parchment-overlay absolute inset-0" aria-hidden="true" />
      <div className="mist opacity-40" aria-hidden="true" />

      <div className="relative max-w-6xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Author photo */}
          <div className="lg:col-span-5 reveal-left">
            <div className="author-frame mx-auto max-w-xs lg:max-w-sm" data-parallax="-0.04">
              <img
                src={AUTHOR_PHOTO}
                alt="Author photo of Chelsea Ray"
                loading="lazy"
                decoding="async"
                className="w-full h-auto block"
              />
            </div>
          </div>

          {/* Bio */}
          <div className="lg:col-span-7 reveal-right" data-stagger="120">
            <p
              data-reveal-child=""
              className="font-accent text-[10px] text-[#c9a25a]"
            >
              About the Author
            </p>
            <h2
              data-testid="about-title"
              data-reveal-child=""
              className="font-display text-4xl md:text-5xl lg:text-6xl text-[#f2e8d5] mt-4 leading-[1.02]"
            >
              Chelsea Ray
            </h2>

            <OrnamentDivider />

            <div className="space-y-5 text-[#cdd6e0] leading-relaxed text-base md:text-[1.05rem]">
              <p data-reveal-child="">
                Chelsea Ray is a hopeless romantic who is addicted to iced
                lattes and all about happily ever afters. She writes fantasy
                adventure with swoon-worthy banter and heroines who persevere,
                which you will find in her debut novel,{" "}
                <em className="text-[#e8d9b6]">Against All Waves</em>.
              </p>
              <p data-reveal-child="">
                When she&rsquo;s not writing, you will find her training
                horses, playing with her corgi, or spending time with her
                husband on their small Kansas ranch.
              </p>
            </div>

            <ul
              className="mt-8 flex flex-wrap gap-2.5"
              aria-label="Things Chelsea loves"
              data-stagger="80"
            >
              {[
                "Iced Lattes",
                "Happily Ever Afters",
                "Horses",
                "Her Corgi",
                "Kansas Ranch Life",
              ].map((t) => (
                <li
                  key={t}
                  data-reveal-child=""
                  className="font-accent text-[10px] text-[#c9a25a] border border-[#c9a25a]/30 px-3 py-1.5 rounded-full bg-[#0a1118]/40 transition-all duration-500 hover:bg-[#c9a25a]/10 hover:border-[#e8c888] hover:-translate-y-0.5"
                >
                  {t}
                </li>
              ))}
            </ul>

            <div className="mt-10 flex flex-col sm:flex-row gap-4 reveal-scale">
              <a
                data-testid="about-cta-newsletter"
                href="#newsletter"
                className="btn-gold btn-gold-solid"
                aria-label="Join the Against All Waves newsletter"
              >
                Join the Crew
              </a>
              <a
                data-testid="about-cta-contact"
                href="#contact"
                className="btn-gold"
                aria-label="Contact Chelsea Ray"
              >
                Write to Chelsea
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
